import { render } from "./Notification.vue?vue&type=template&id=4103d5cf&ts=true"
import script from "./Notification?vue&type=script&lang=ts&external"
export * from "./Notification?vue&type=script&lang=ts&external"

import "./Notification.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__